module.exports = __webpack_public_path__ + "static/au_lait-e72d72aa1461a79df454c6aebb7ea1b8.png";